import DevicePhoneDetails from "./DevicePhoneDetails.vue";

const devicePhoneDetailsCtrl = new Vue({
    el: '#device-phone-details',
    components: {DevicePhoneDetails},
})
